import { Copy01 } from "@untitled-ui/icons-react";
import { useTranslation } from "react-i18next";

type GroupInviteLinkFieldProps = {
  inviteUrl: string;
  onCopy: () => void;
};

export default function GroupInviteLinkField({
  inviteUrl,
  onCopy,
}: GroupInviteLinkFieldProps) {
  const { t } = useTranslation("messenger.user");

  return (
    <div className="flex flex-col gap-4 px-6 py-4">
      <div className="flex flex-col gap-1">
        <span className="text-md font-semibold text-gray-900">
          {t("Invite Link")}
        </span>
        <span className="text-sm text-gray-600">
          {t("Users can join the group using this link.")}
        </span>
      </div>
      <div className="flex items-center overflow-hidden rounded-lg border border-gray-300 bg-white">
        <button
          type="button"
          className="flex shrink-0 items-center gap-1.5 border-e border-gray-300 px-3 py-2.5 text-sm font-medium text-gray-700 hover:bg-gray-50"
          onClick={onCopy}
        >
          <Copy01 className="size-5 text-gray-600" />
          {t("Copy")}
        </button>
        <span
          className="min-w-0 flex-1 truncate px-3 py-2.5 text-sm text-gray-700"
          dir="ltr"
        >
          {inviteUrl}
        </span>
      </div>
    </div>
  );
}
